export const REQUEST_STATE = 'REQUEST_STATE'
export const SET_ERROR = 'SET_ERROR'
export const SET_LOADING = 'SET_LOADING'

export const LOGOUT = 'LOGOUT'

//AUTH
export const CORE_AUTH_VERIFY_REQUEST = 'CORE_AUTH_VERIFY_REQUEST'
export const CORE_AUTH_VERIFY_SUCCESS = 'CORE_AUTH_VERIFY_SUCCESS'
export const CORE_AUTH_VERIFY_FAILURE = 'CORE_AUTH_VERIFY_FAILURE'

export const AUTH_REQUEST_FORGOT_PASSWORD_REQUEST = 'CORE_AUTH_VERIFY_REQUEST'
export const AUTH_REQUEST_FORGOT_PASSWORD_SUCCESS = 'CORE_AUTH_VERIFY_SUCCESS'
export const AUTH_REQUEST_FORGOT_PASSWORD_FAILURE = 'CORE_AUTH_VERIFY_FAILURE'

export const CORE_LOAD_USER_REQUEST = 'CORE_LOAD_USER_REQUEST'
export const CORE_LOAD_USER_SUCCESS = 'CORE_LOAD_USER_SUCCESS'
export const CORE_LOAD_USER_FAILURE = 'CORE_LOAD_USER_FAILURE'

export const CORE_LOAD_USER_BY_ID_REQUEST = 'CORE_LOAD_USER_BY_ID_REQUEST'
export const CORE_LOAD_USER_BY_ID_SUCCESS = 'CORE_LOAD_USER_BY_ID_SUCCESS'
export const CORE_LOAD_USER_BY_ID_FAILURE = 'CORE_LOAD_USER_BY_ID_FAILURE'

export const CORE_CREATE_USER_REQUEST = 'CORE_CREATE_USER_REQUEST'
export const CORE_CREATE_USER_SUCCESS = 'CORE_CREATE_USER_SUCCESS'
export const CORE_CREATE_USER_FAILURE = 'CORE_CREATE_USER_FAILURE'

export const CORE_UPDATE_USER_REQUEST = 'CORE_UPDATE_USER_REQUEST'
export const CORE_UPDATE_USER_SUCCESS = 'CORE_UPDATE_USER_SUCCESS'
export const CORE_UPDATE_USER_FAILURE = 'CORE_UPDATE_USER_FAILURE'

export const CORE_LOAD_USER_GROUP_REQUEST = 'CORE_LOAD_USER_GROUP_REQUEST'
export const CORE_LOAD_USER_GROUP_SUCCESS = 'CORE_LOAD_USER_GROUP_SUCCESS'
export const CORE_LOAD_USER_GROUP_FAILURE = 'CORE_LOAD_USER_GROUP_FAILURE'

export const CORE_LOAD_USER_GROUP_BY_ID_REQUEST = 'CORE_LOAD_USER_GROUP_BY_ID_REQUEST'
export const CORE_LOAD_USER_GROUP_BY_ID_SUCCESS = 'CORE_LOAD_USER_GROUP_BY_ID_SUCCESS'
export const CORE_LOAD_USER_GROUP_BY_ID_FAILURE = 'CORE_LOAD_USER_GROUP_BY_ID_FAILURE'

export const CORE_CREATE_USER_GROUP_REQUEST = 'CORE_CREATE_USER_GROUP_REQUEST'
export const CORE_CREATE_USER_GROUP_SUCCESS = 'CORE_CREATE_USER_GROUP_SUCCESS'
export const CORE_CREATE_USER_GROUP_FAILURE = 'CORE_CREATE_USER_GROUP_FAILURE'

export const CORE_UPDATE_USER_GROUP_REQUEST = 'CORE_UPDATE_USER_GROUP_REQUEST'
export const CORE_UPDATE_USER_GROUP_SUCCESS = 'CORE_UPDATE_USER_GROUP_SUCCESS'
export const CORE_UPDATE_USER_GROUP_FAILURE = 'CORE_UPDATE_USER_GROUP_FAILURE'

export const CORE_DELETE_USER_GROUP_REQUEST = 'CORE_DELETE_USER_GROUP_REQUEST'
export const CORE_DELETE_USER_GROUP_SUCCESS = 'CORE_DELETE_USER_GROUP_SUCCESS'
export const CORE_DELETE_USER_GROUP_FAILURE = 'CORE_DELETE_USER_GROUP_FAILURE'

export const CORE_LOAD_SITE_REQUEST = 'CORE_LOAD_SITE_REQUEST'
export const CORE_LOAD_SITE_SUCCESS = 'CORE_LOAD_SITE_SUCCESS'
export const CORE_LOAD_SITE_FAILURE = 'CORE_LOAD_SITE_FAILURE'

export const CORE_LOAD_SITE_BY_ID_REQUEST = 'CORE_LOAD_SITE_BY_ID_REQUEST'
export const CORE_LOAD_SITE_BY_ID_SUCCESS = 'CORE_LOAD_SITE_BY_ID_SUCCESS'
export const CORE_LOAD_SITE_BY_ID_FAILURE = 'CORE_LOAD_SITE_BY_ID_FAILURE'

export const CORE_CREATE_SITE_REQUEST = 'CORE_CREATE_SITE_REQUEST'
export const CORE_CREATE_SITE_SUCCESS = 'CORE_CREATE_SITE_SUCCESS'
export const CORE_CREATE_SITE_FAILURE = 'CORE_CREATE_SITE_FAILURE'

export const CORE_UPDATE_SITE_REQUEST = 'CORE_UPDATE_SITE_REQUEST'
export const CORE_UPDATE_SITE_SUCCESS = 'CORE_UPDATE_SITE_SUCCESS'
export const CORE_UPDATE_SITE_FAILURE = 'CORE_UPDATE_SITE_FAILURE'

export const CORE_DELETE_SITE_REQUEST = 'CORE_DELETE_SITE_REQUEST'
export const CORE_DELETE_SITE_SUCCESS = 'CORE_DELETE_SITE_SUCCESS'
export const CORE_DELETE_SITE_FAILURE = 'CORE_DELETE_SITE_FAILURE'

export const CORE_LOAD_STATION_REQUEST = 'CORE_LOAD_STATION_REQUEST'
export const CORE_LOAD_STATION_SUCCESS = 'CORE_LOAD_STATION_SUCCESS'
export const CORE_LOAD_STATION_FAILURE = 'CORE_LOAD_STATION_FAILURE'

export const CORE_LOAD_STATION_BY_ID_REQUEST = 'CORE_LOAD_STATION_BY_ID_REQUEST'
export const CORE_LOAD_STATION_BY_ID_SUCCESS = 'CORE_LOAD_STATION_BY_ID_SUCCESS'
export const CORE_LOAD_STATION_BY_ID_FAILURE = 'CORE_LOAD_STATION_BY_ID_FAILURE'

export const CORE_GET_REPORT_REQUEST = 'CORE_GET_REPORT_REQUEST'
export const CORE_GET_REPORT_SUCCESS = 'CORE_GET_REPORT_SUCCESS'
export const CORE_GET_REPORT_FAILURE = 'CORE_GET_REPORT_FAILURE'

export const CORE_GET_STATION_REQUEST = 'CORE_GET_STATION_REQUEST'
export const CORE_GET_STATION_SUCCESS = 'CORE_GET_STATION_SUCCESS'
export const CORE_GET_STATION_FAILURE = 'CORE_GET_STATION_FAILURE'

export const CORE_GET_EXCEL_REPORT_REQUEST = 'CORE_GET_EXCEL_REPORT_REQUEST'
export const CORE_GET_EXCEL_REPORT_SUCCESS = 'CORE_GET_EXCEL_REPORT_SUCCESS'
export const CORE_GET_EXCEL_REPORT_FAILURE = 'CORE_GET_EXCEL_REPORT_FAILURE'

export const CORE_GET_STATION_LIST_REQUEST = 'CORE_GET_STATION_LIST_REQUEST'
export const CORE_GET_STATION_LIST_SUCCESS = 'CORE_GET_STATION_LIST_SUCCESS'
export const CORE_GET_STATION_LIST_FAILURE = 'CORE_GET_STATION_LIST_FAILURE'

export const CORE_GET_DEVICE_LIST_REQUEST = 'CORE_GET_DEVICE_LIST_REQUEST'
export const CORE_GET_DEVICE_LIST_SUCCESS = 'CORE_GET_DEVICE_LIST_SUCCESS'
export const CORE_GET_DEVICE_LIST_FAILURE = 'CORE_GET_DEVICE_LIST_FAILURE'

export const CORE_GET_DEVICE_BY_PLANTCODE_REQUEST = 'CORE_GET_DEVICE_BY_PLANTCODE_REQUEST'
export const CORE_GET_DEVICE_BY_PLANTCODE_SUCCESS = 'CORE_GET_DEVICE_BY_PLANTCODE_SUCCESS'
export const CORE_GET_DEVICE_BY_PLANTCODE_FAILURE = 'CORE_GET_DEVICE_BY_PLANTCODE_FAILURE'

export const CORE_GET_DEVICE_KPI_REQUEST = 'CORE_GET_DEVICE_KPI_REQUEST'
export const CORE_GET_DEVICE_KPI_SUCCESS = 'CORE_GET_DEVICE_KPI_SUCCESS'
export const CORE_GET_DEVICE_KPI_FAILURE = 'CORE_GET_DEVICE_KPI_FAILURE'

export const CORE_GET_DEVICE_FIVE_MINUTES_REQUEST = 'CORE_GET_DEVICE_FIVE_MINUTES_REQUEST'
export const CORE_GET_DEVICE_FIVE_MINUTES_SUCCESS = 'CORE_GET_DEVICE_FIVE_MINUTES_SUCCESS'
export const CORE_GET_DEVICE_FIVE_MINUTES_FAILURE = 'CORE_GET_DEVICE_FIVE_MINUTES_FAILURE'

export const CORE_GET_KPI_STATION_HOUR_REQUEST = 'CORE_GET_KPI_STATION_HOUR_REQUEST'
export const CORE_GET_KPI_STATION_HOUR_SUCCESS = 'CORE_GET_KPI_STATION_HOUR_SUCCESS'
export const CORE_GET_KPI_STATION_HOUR_FAILURE = 'CORE_GET_KPI_STATION_HOUR_FAILURE'

export const CORE_GET_KPI_STATION_DAY_REQUEST = 'CORE_GET_KPI_STATION_DAY_REQUEST'
export const CORE_GET_KPI_STATION_DAY_SUCCESS = 'CORE_GET_KPI_STATION_DAY_SUCCESS'
export const CORE_GET_KPI_STATION_DAY_FAILURE = 'CORE_GET_KPI_STATION_DAY_FAILURE'

export const CORE_GET_KPI_STATION_MONTH_REQUEST = 'CORE_GET_KPI_STATION_MONTH_REQUEST'
export const CORE_GET_KPI_STATION_MONTH_SUCCESS = 'CORE_GET_KPI_STATION_MONTH_SUCCESS'
export const CORE_GET_KPI_STATION_MONTH_FAILURE = 'CORE_GET_KPI_STATION_MONTH_FAILURE'

export const CORE_GET_KPI_STATION_YEAR_REQUEST = 'CORE_GET_KPI_STATION_YEAR_REQUEST'
export const CORE_GET_KPI_STATION_YEAR_SUCCESS = 'CORE_GET_KPI_STATION_YEAR_SUCCESS'
export const CORE_GET_KPI_STATION_YEAR_FAILURE = 'CORE_GET_KPI_STATION_YEAR_FAILURE'

export const CORE_GET_STATION_REAL_KPI_REQUEST = 'CORE_GET_STATION_REAL_KPI_REQUEST'
export const CORE_GET_STATION_REAL_KPI_SUCCESS = 'CORE_GET_STATION_REAL_KPI_SUCCESS'
export const CORE_GET_STATION_REAL_KPI_FAILURE = 'CORE_GET_STATION_REAL_KPI_FAILURE'

export const CORE_GET_STATION_REAL_KPI_HOMESITE_REQUEST = 'CORE_GET_STATION_REAL_KPI_HOMESITE_REQUEST'
export const CORE_GET_STATION_REAL_KPI_HOMESITE_SUCCESS = 'CORE_GET_STATION_REAL_KPI_HOMESITE_SUCCESS'
export const CORE_GET_STATION_REAL_KPI_HOMESITE_FAILURE = 'CORE_GET_STATION_REAL_KPI_HOMESITE_FAILURE'

export const CORE_GET_ALL_DEVICE_REQUEST = 'CORE_GET_ALL_DEVICE_REQUEST'
export const CORE_GET_ALL_DEVICE_SUCCESS = 'CORE_GET_ALL_DEVICE_SUCCESS'
export const CORE_GET_ALL_DEVICE_FAILURE = 'CORE_GET_ALL_DEVICE_FAILURE'

export const CORE_GET_DEVICE_KPI_DAY_REQUEST = 'CORE_GET_DEVICE_KPI_DAY_REQUEST'
export const CORE_GET_DEVICE_KPI_DAY_SUCCESS = 'CORE_GET_DEVICE_KPI_DAY_SUCCESS'
export const CORE_GET_DEVICE_KPI_DAY_FAILURE = 'CORE_GET_DEVICE_KPI_DAY_FAILURE'

export const CORE_GET_DEVICE_KPI_MONTH_REQUEST = 'CORE_GET_DEVICE_KPI_MONTH_REQUEST'
export const CORE_GET_DEVICE_KPI_MONTH_SUCCESS = 'CORE_GET_DEVICE_KPI_MONTH_SUCCESS'
export const CORE_GET_DEVICE_KPI_MONTH_FAILURE = 'CORE_GET_DEVICE_KPI_MONTH_FAILURE'

export const CORE_GET_DEVICE_KPI_YEAR_REQUEST = 'CORE_GET_DEVICE_KPI_YEAR_REQUEST'
export const CORE_GET_DEVICE_KPI_YEAR_SUCCESS = 'CORE_GET_DEVICE_KPI_YEAR_SUCCESS'
export const CORE_GET_DEVICE_KPI_YEAR_FAILURE = 'CORE_GET_DEVICE_KPI_YEAR_FAILURE'

export const CORE_CHANGE_USER_PROFILE_REQUEST = 'CORE_CHANGE_USER_PROFILE_REQUEST'
export const CORE_CHANGE_USER_PROFILE_SUCCESS = 'CORE_CHANGE_USER_PROFILE_SUCCESS'
export const CORE_CHANGE_USER_PROFILE_FAILURE = 'CORE_CHANGE_USER_PROFILE_FAILURE'

export const CORE_GET_ALL_COMPANY_REQUEST = 'CORE_GET_ALL_COMPANY_REQUEST'
export const CORE_GET_ALL_COMPANY_SUCCESS = 'CORE_GET_ALL_COMPANY_SUCCESS'
export const CORE_GET_ALL_COMPANY_FAILURE = 'CORE_GET_ALL_COMPANY_FAILURE'

export const CORE_GET_COMPANY_BY_ID_REQUEST = 'CORE_GET_COMPANY_BY_ID_REQUEST'
export const CORE_GET_COMPANY_BY_ID_SUCCESS = 'CORE_GET_COMPANY_BY_ID_SUCCESS'
export const CORE_GET_COMPANY_BY_ID_FAILURE = 'CORE_GET_COMPANY_BY_ID_FAILURE'

export const CORE_CHANGE_IMG_SITE_REQUEST = 'CORE_CHANGE_IMG_SITE_REQUEST'
export const CORE_CHANGE_IMG_SITE_SUCCESS = 'CORE_CHANGE_IMG_SITE_SUCCESS'
export const CORE_CHANGE_IMG_SITE_FAILURE = 'CORE_CHANGE_IMG_SITE_FAILURE'

export const CORE_CHANGE_IMG_DEVICE_REQUEST = 'CORE_CHANGE_IMG_DEVICE_REQUEST'
export const CORE_CHANGE_IMG_DEVICE_SUCCESS = 'CORE_CHANGE_IMG_DEVICE_SUCCESS'
export const CORE_CHANGE_IMG_DEVICE_FAILURE = 'CORE_CHANGE_IMG_DEVICE_FAILURE'

export const CORE_DELETE_USER_REQUEST = 'CORE_DELETE_USER_REQUEST'
export const CORE_DELETE_USER_SUCCESS = 'CORE_DELETE_USER_SUCCESS'
export const CORE_DELETE_USER_FAILURE = 'CORE_DELETE_USER_FAILURE'

export const CORE_UPDATE_COMPANY_REQUEST = 'CORE_UPDATE_COMPANY_REQUEST'
export const CORE_UPDATE_COMPANY_SUCCESS = 'CORE_UPDATE_COMPANY_SUCCESS'
export const CORE_UPDATE_COMPANY_FAILURE = 'CORE_UPDATE_COMPANY_FAILURE'

export const CORE_CREATE_COMPANY_REQUEST = 'CORE_CREATE_COMPANY_REQUEST'
export const CORE_CREATE_COMPANY_SUCCESS = 'CORE_CREATE_COMPANY_SUCCESS'
export const CORE_CREATE_COMPANY_FAILURE = 'CORE_CREATE_COMPANY_FAILURE'

export const CORE_GET_DEVICE_GET_KPI_REQUEST = 'CORE_GET_DEVICE_GET_KPI_REQUEST'
export const CORE_GET_DEVICE_GET_KPI_SUCCESS = 'CORE_GET_DEVICE_GET_KPI_SUCCESS'
export const CORE_GET_DEVICE_GET_KPI_FAILURE = 'CORE_GET_DEVICE_GET_KPI_FAILURE'

export const CORE_GET_STATION_KPI_HOUR_REQUEST = 'CORE_GET_STATION_KPI_HOUR_REQUEST'
export const CORE_GET_STATION_KPI_HOUR_SUCCESS = 'CORE_GET_STATION_KPI_HOUR_SUCCESS'
export const CORE_GET_STATION_KPI_HOUR_FAILURE = 'CORE_GET_STATION_KPI_HOUR_FAILURE'

export const CORE_GET_STATION_KPI_DAY_REQUEST = 'CORE_GET_STATION_KPI_DAY_REQUEST'
export const CORE_GET_STATION_KPI_DAY_SUCCESS = 'CORE_GET_STATION_KPI_DAY_SUCCESS'
export const CORE_GET_STATION_KPI_DAY_FAILURE = 'CORE_GET_STATION_KPI_DAY_FAILURE'

export const CORE_GET_STATION_KPI_MONTH_REQUEST = 'CORE_GET_STATION_KPI_MONTH_REQUEST'
export const CORE_GET_STATION_KPI_MONTH_SUCCESS = 'CORE_GET_STATION_KPI_MONTH_SUCCESS'
export const CORE_GET_STATION_KPI_MONTH_FAILURE = 'CORE_GET_STATION_KPI_MONTH_FAILURE'

export const CORE_GET_STATION_KPI_YEAR_REQUEST = 'CORE_GET_STATION_KPI_YEAR_REQUEST'
export const CORE_GET_STATION_KPI_YEAR_SUCCESS = 'CORE_GET_STATION_KPI_YEAR_SUCCESS'
export const CORE_GET_STATION_KPI_YEAR_FAILURE = 'CORE_GET_STATION_KPI_YEAR_FAILURE'

export const CORE_GET_DEVICE_GET_KPI_DAY_REQUEST = 'CORE_GET_DEVICE_GET_KPI_DAY_REQUEST'
export const CORE_GET_DEVICE_GET_KPI_DAY_SUCCESS = 'CORE_GET_DEVICE_GET_KPI_DAY_SUCCESS'
export const CORE_GET_DEVICE_GET_KPI_DAY_FAILURE = 'CORE_GET_DEVICE_GET_KPI_DAY_FAILURE'

export const CORE_GET_DEVICE_GET_KPI_MONTH_REQUEST = 'CORE_GET_DEVICE_GET_KPI_MONTH_REQUEST'
export const CORE_GET_DEVICE_GET_KPI_MONTH_SUCCESS = 'CORE_GET_DEVICE_GET_KPI_MONTH_SUCCESS'
export const CORE_GET_DEVICE_GET_KPI_MONTH_FAILURE = 'CORE_GET_DEVICE_GET_KPI_MONTH_FAILURE'

export const CORE_GET_DEVICE_GET_KPI_YEAR_REQUEST = 'CORE_GET_DEVICE_GET_KPI_YEAR_REQUEST'
export const CORE_GET_DEVICE_GET_KPI_YEAR_SUCCESS = 'CORE_GET_DEVICE_GET_KPI_YEAR_SUCCESS'
export const CORE_GET_DEVICE_GET_KPI_YEAR_FAILURE = 'CORE_GET_DEVICE_GET_KPI_YEAR_FAILURE'

export const CORE_API_AIR_REQUEST = 'CORE_API_AIR_REQUEST'
export const CORE_API_AIR_SUCCESS = 'CORE_API_AIR_SUCCESS'
export const CORE_API_AIR_FAILURE = 'CORE_API_AIR_FAILURE'

export const CORE_API_AIR_WIND_REQUEST = 'CORE_API_AIR_WIND_REQUEST'
export const CORE_API_AIR_WIND_SUCCESS = 'CORE_API_AIR_WIND_SUCCESS'
export const CORE_API_AIR_WIND_FAILURE = 'CORE_API_AIR_WIND_FAILURE'

export const CORE_API_AIR_17_REQUEST = 'CORE_API_AIR_17_REQUEST'
export const CORE_API_AIR_17_SUCCESS = 'CORE_API_AIR_17_SUCCESS'
export const CORE_API_AIR_17_FAILURE = 'CORE_API_AIR_17_FAILURE'

export const CORE_API_AIR_WIND_17_REQUEST = 'CORE_API_AIR_WIND_17_REQUEST'
export const CORE_API_AIR_WIND_17_SUCCESS = 'CORE_API_AIR_WIND_17_SUCCESS'
export const CORE_API_AIR_WIND_17_FAILURE = 'CORE_API_AIR_WIND_17_FAILURE'

export const CORE_API_AIR_PRESSURE_17_REQUEST = 'CORE_API_AIR_PRESSURE_17_REQUEST'
export const CORE_API_AIR_PRESSURE_17_SUCCESS = 'CORE_API_AIR_PRESSURE_17_SUCCESS'
export const CORE_API_AIR_PRESSURE_17_FAILURE = 'CORE_API_AIR_PRESSURE_17_FAILURE'

export const CORE_API_AIR_CLOUD_17_REQUEST = 'CORE_API_AIR_CLOUD_17_REQUEST'
export const CORE_API_AIR_CLOUD_17_SUCCESS = 'CORE_API_AIR_CLOUD_17_SUCCESS'
export const CORE_API_AIR_CLOUD_17_FAILURE = 'CORE_API_AIR_CLOUD_17_FAILURE'

export const CORE_API_AIR_PRESSURE_REQUEST = 'CORE_API_AIR_PRESSURE_REQUEST'
export const CORE_API_AIR_PRESSURE_SUCCESS = 'CORE_API_AIR_PRESSURE_SUCCESS'
export const CORE_API_AIR_PRESSURE_FAILURE = 'CORE_API_AIR_PRESSURE_FAILURE'

export const CORE_API_AIR_CLOUD_REQUEST = 'CORE_API_AIR_CLOUD_REQUEST'
export const CORE_API_AIR_CLOUD_SUCCESS = 'CORE_API_AIR_CLOUD_SUCCESS'
export const CORE_API_AIR_CLOUD_FAILURE = 'CORE_API_AIR_CLOUD_FAILURE'








// WEBPACK FOOTER //
// ./src/app/redux/types.js